"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var DatingTipsComponent = /** @class */ (function () {
    function DatingTipsComponent() {
    }
    DatingTipsComponent.prototype.ngOnInit = function () {
    };
    return DatingTipsComponent;
}());
exports.DatingTipsComponent = DatingTipsComponent;
